const rawApiUrl =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_API_URL) ||
  (typeof process !== "undefined" && process.env && process.env.VITE_API_URL) ||
  "";

export const apiUrl = rawApiUrl.replace(/\/$/, "");
